import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa'; // For close icon

const Lightbox = ({ image, onClose }) => (
  <div className="lightbox-overlay" onClick={onClose}>
    <motion.div
      className="lightbox-content"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0.8, opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={(e) => e.stopPropagation()}
    >
      <button className="lightbox-close-btn" onClick={onClose}><FaTimes /></button>
      <img src={image} alt="lightbox" className="lightbox-image" />
    </motion.div>
  </div>
);

const Gallery = ({ lightbox = true, gallerySize = "large" }) => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const galleryRef = useRef(null);

  const fetchImages = async () => {
    try {
      const response = await axios.get('https://ethiccraft.org/backend/gallery/read_isShown.php');
      setImages(response.data.map(item => `https://ethiccraft.org/${item.image}`));
    } catch (error) {
      console.error('Failed to fetch images:', error);
    }
  };

  const handleImageClick = (image) => lightbox && setSelectedImage(image);
  const handleCloseLightbox = () => setSelectedImage(null);

  useEffect(() => {
    fetchImages();
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );
    if (galleryRef.current) observer.observe(galleryRef.current);
    return () => {
      if (galleryRef.current) observer.unobserve(galleryRef.current);
    };
  }, []);

  return (
    <div ref={galleryRef}>
      <h1 className="gallery-title gradient-text fade-in">Gallery</h1>
      <div className={`gallery ${gallerySize}`}>
        {images.length > 0 ? (
          images.map((image, index) => (
            <motion.div
              key={index}
              className="gallery-item"
              initial={{ opacity: 0, y: 30 }}
              animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <img
                src={image}
                alt={`gallery-item-${index}`}
                className="gallery-image"
                onClick={() => handleImageClick(image)}
              />
            </motion.div>
          ))
        ) : (
          <p className="loading-text">.</p>
        )}
        <AnimatePresence>
          {selectedImage && (
            <Lightbox image={selectedImage} onClose={handleCloseLightbox} />
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Gallery;